import { defaultProps } from 'recompose';

import Input from '@/components/AutocompleteBase/Input';

export default defaultProps({ hideInputWhenSelected: false })(Input);
